import {
  ApolloClient,
  ApolloLink,
  concat,
  createHttpLink,
  InMemoryCache,
} from "@apollo/client/core";
import { DefaultApolloClient, ApolloClients } from "@vue/apollo-composable";
import { createGraphQLErrorHandler } from "./createGraphQLErrorHandler";

export function createApolloClient() {
  // const { protocol, hostname } = location;
  const uri = "//overlord-api.ksyun.com/console-v2";
  __DEV__ && console.info("apollo uri:", uri);
  const httpLink = createHttpLink({
    // uri,
    credentials: "include",
  });
  const cache = new InMemoryCache();

  function guid() {
    function S4() {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }
    return S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4();
  }

  const requestIdMid = new ApolloLink((operation, forward) => {
    operation.setContext(({ headers = {} }) => ({
      uri: `${uri}?operationName=${operation.operationName}`,
      headers: {
        ...headers,
        "x-trace-id": guid(),
      },
    }));
    return forward(operation);
  });
  const errorLink = createGraphQLErrorHandler();
  const apolloClient = new ApolloClient({
    link: concat(errorLink, concat(requestIdMid, httpLink)),
    cache,
  });

  return apolloClient;
}

export const defaultApolloClient = createApolloClient();

export const apolloClientPlugin = {
  install<TCacheShape>(
    app: any,
    options?: ApolloClient<TCacheShape> | Record<string, ApolloClient<TCacheShape>>,
  ) {
    if (!options) {
      app.provide(DefaultApolloClient, defaultApolloClient);
      return;
    }

    if (options instanceof ApolloClient) {
      app.provide(DefaultApolloClient, options);
    } else {
      app.provide(ApolloClients, options);
    }
  },
};
